import { useCallback, useMemo } from 'react'

import { continents, countries, languages } from 'countries-list'

export const useISOCountryData = () => {
  const countryOptions = useMemo(
    () =>
      Object.entries(countries).map(([code, country]) => ({
        label: country.name,
        value: code,
        region: continents[country.continent],
      })),
    []
  )

  const getCountryNameByCode = useCallback(
    (countryCode: string) => countries[countryCode]?.name,
    []
  )

  const getLanguageNameByCode = useCallback(
    (languageCode: string) => languages[languageCode]?.name,
    []
  )

  return { countryOptions, getCountryNameByCode, getLanguageNameByCode }
}
